import React, { Component } from 'react';
import Top_Bar from '../Part_Sample/Top_Bar';
import { isEmpty } from '../Common/Common';

import CO from '../../Images/iaq_icons/CO.png';
import CO2 from '../../Images/iaq_icons/CO2.png';
import Humidity from '../../Images/iaq_icons/Humid.png';
import Pm25 from '../../Images/iaq_icons/PM25.png';
import Temp from '../../Images/iaq_icons/Temp.png';
import TVOC from '../../Images/iaq_icons/TVOC.png';

import Chart_Line from '../Part_Sample/Chart_Line';

//import { getTrendTimeSeries } from '../Reports/util/util';

export default class IAQ_Mon_Details extends Component {
	constructor(props) {
		super(props);
		// Retain scroll position of groups screen
		this.state = {
			height: 0,
			selectedPoint: null,
			yellowLabel: '',
			redLabel: '',
			chartData: [],
			colors: {},
			tick_values: [],
			y_label: '',
			minValue: 0,
			maxValue: 0
		}

		this.chart = React.createRef();
	}

	componentDidMount = () => {
		if (this.props.param.iaq_monitoring_settings) {
			//get element height to calculate square
			const height = this.divElement.clientHeight;
			this.setState({ height });
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		window.app.content_area.current.content_handler('IAQ_Monitoring', { iaq_scroll_top: this.props.param.iaq_scroll_top, iaq_monitoring_settings: this.props.param.iaq_monitoring_settings });
	}

	selectedIAQValue = (device) => {
		window.app.showLoading();

		this.setState({
			selectedPoint: device,
		}, () => {
			this.search_date = new Date();
			this.search_date.setHours(0, 0, 0);
			this.search_end_date = new Date(this.search_date);
			this.search_end_date.setDate(this.search_end_date.getDate() + 1);

			let reportType = 'non'
			if(window.app.state.point_list[this.state.selectedPoint.id].hasOwnProperty('type')) {
				if(window.app.state.point_list[this.state.selectedPoint.id].type == 'Ac') reportType = 'temp';
			}

			let search_details = {
				fy: this.search_date.getFullYear(),
				fm: this.search_date.getMonth() + 1,
				fd: this.search_date.getDate(),
				fh: 0,
				fmin: 0,
				ty: this.search_end_date.getFullYear(),
				tm: this.search_end_date.getMonth() + 1,
				td: this.search_end_date.getDate(),
				th: 0,
				tmin: 0,
				points: [[this.state.selectedPoint.id, reportType]]
			}

			this.props.receiver.getTrend(search_details);
		});
	}

	rcvTrendData(trendData) {
		window.app.hideLoading();

		let device = this.state.selectedPoint;
		let yellowLabel = 'caution';
		let redLabel = 'warning';
		
		//manipulate chartData
		let rawData = {};

		if(trendData['data'][device.id].hasOwnProperty('non')) {
			rawData = JSON.parse(JSON.stringify(trendData['data'][device.id]['non']));
		} else {
			rawData = JSON.parse(JSON.stringify(trendData['data'][device.id]['temp']));
		}

		let chartData = [['x'], [window.app.state.point_list[device.id].name]];

		let reportUnit = window.app.state.point_list[device.id].unit;

		if(isEmpty(reportUnit)) {
			if(window.app.state.point_list[device.id].type == 'Ac') reportUnit = 'DEG';
		}

		let y_label = this.props.receiver.getString(device.type) + '  ' + this.props.receiver.getString(reportUnit);
		let tick_values = [];

		rawData.map(rec => {
			let dateString = rec[0].toString();

			let year = dateString.substring(0, 4);
			let month = dateString.substring(4, 6);
			let day = dateString.substring(6, 8);
			let hour = dateString.substring(8, 10);
			let minute = dateString.substring(10);

			let timeStamp = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':00';

			chartData[0].push(timeStamp);
			//chartData[0].push(new Date(timeStamp));
			//chartData[0].push(new Date(year, month, day, hour, minute, 0, 0));
			chartData[1].push(rec[1]);

			if(minute == '00') {
				//tick_values.push(new Date(timeStamp));
				tick_values.push(timeStamp);
			}
		});

		//Setting tick_values, X axis labels. START
// 		let startDate = rawData[0][0].toString();
// 		let endDate = rawData[rawData.length - 1][0].toString();

// 		let startDateObj = startDate.substring(0, 4) + '-' + startDate.substring(4, 6) + '-' + startDate.substring(6, 8) + ' ' + startDate.substring(8, 10) + ':' + startDate.substring(10) + ':00';
// 		let duration = parseInt(endDate.substring(8, 10)) + 1;
// 		let interval = 60;

// 		let tick_values = [];
// 		tick_values = getTrendTimeSeries(startDateObj, duration, interval);
// 		tick_values.shift();	//remove first element
// console.log('!!** getTrendFunction: ' + JSON.stringify(getTrendTimeSeries(startDateObj, duration, interval)));
//console.log('!!!*** tick_values: ' + JSON.stringify(tick_values));
		// for (var i = 0; i < tick_values.length; i++) {
		// 	let time_stamp_arr = tick_values[i].split(' ');		//2013-01-01 00:00:00
		// 	let date_arr = time_stamp_arr[0].split('-'); 		//2013-01-01
		// 	let time_arr = time_stamp_arr[1].split(':'); 		//00:00:00
		// 	let year = date_arr[0];
		// 	let month = date_arr[1];
		// 	let day = date_arr[2];
		// 	let hour = time_arr[0];
		// 	let minute = time_arr[1];
		// 	let second = time_arr[2];
		// 	//let temp_date = new Date(year, month, day, hour, minute, second, 0, 0);

		// 	tick_values[i] = new Date(year, month, day, hour, minute, second, 0, 0);
		// }
		//Setting tick_values, X axis labels. END

		if (device.type == 'temp' || device.type == 'humi') {
			yellowLabel = 'lower';
			redLabel = 'upper';
		}

		let colors = {};
		colors[device.id] = '#1F77B4';

		//Figure out the range of Y axis, for displaying min max threshold START
		let lowerThreshold = device.threshold_yellow;
		let upperThreshold = device.threshold_red;

		let minValue = 0;
		let maxValue = 0;

		let dataArray = JSON.parse(JSON.stringify(chartData));

		if (dataArray.length > 0) {
			dataArray = dataArray[1];

			dataArray.splice(0, 1);

			minValue = Math.min(...dataArray);

			maxValue = Math.max(...dataArray);

			if (minValue > lowerThreshold) {
				minValue = lowerThreshold;
			}

			if (maxValue < upperThreshold) {
				maxValue = upperThreshold;
			}
		}
		//Figure out the range of Y axis, for displaying min max threshold END

		this.setState({
			yellowLabel: 'threshold-' + yellowLabel,
			redLabel: 'threshold-' + redLabel,
			chartData: chartData,
			colors: colors,
			tick_values: tick_values,
			y_label: y_label,
			minValue: minValue,
			maxValue: maxValue
		}, () => { this.chart.current.generateChart() });
	}

	render() {
		let style = {
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: 'auto'
		}

		let cell_width = this.props.width - 40;

		let cell_style = {
			//cursor: 'pointer',
			width: cell_width,
			minHeight: 60,
			maxHeight: 200,
			margin: 5,
			padding: 10,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			borderRadius: 20,
			overflow: 'auto'
		}
		//{ display: 'inline-block', width: '90%', marginBottom: '10px', border: '1px solid black' }

		let room_name = this.props.param.room_name;
		let room_color = '#8BD5A7';
		//#cc3300, #ff9966, #ffcc00, #99cc33, #339900
		//red, 	   beige.	yellow,	 light green, green
		//#FF6D6A			#FDE26C				   #8BD5A7

		this.props.param.iaq_monitoring_settings[room_name].map((device, i) => {
			let avTemp = window.app.state.point_list[device.id].av;

			if(isEmpty(avTemp)) {
				if(window.app.state.point_list[device.id].type == 'Ac') {
					if(window.app.state.point_list[device.id].hasOwnProperty('temp')) {
						avTemp = window.app.state.point_list[device.id].temp;
					}
				}
			}

			if(avTemp != null && avTemp != 'null') {
				if (device.type == 'temp' || device.type == 'humi') {
					if (avTemp <= device.threshold_yellow || avTemp >= device.threshold_red) {
						if (room_color != '#FF6D6A') room_color = '#FDE26C';
					}
				} else {
					if (avTemp >= device.threshold_red) {
						room_color = '#FF6D6A';
					} else {
						if (avTemp >= device.threshold_yellow) {
							if (room_color != '#FF6D6A') room_color = '#FDE26C';
						}
					}
				}
			}
		});

		let chart_width = this.props.width - 10;
		let chart_height = this.props.height - 213;

		const rgbaCode = {
			'#FF6D6A': { 'r': 255, 'g': 109, 'b': 106 },
			'#FDE26C': { 'r': 253, 'g': 226, 'b': 108 },
			'#8BD5A7': { 'r': 139, 'g': 213, 'b': 167 },
		};

		const opacityValue = 1;

		const iconList = {
			'co': CO,
			'co2': CO2,
			'humi': Humidity,
			'pm25': Pm25,
			'temp': Temp,
			'tvoc': TVOC,
		};

		let roomRGBA = 'rgba(' + rgbaCode[room_color].r + ', ' + rgbaCode[room_color].g + ', ' + rgbaCode[room_color].b + ', ' + opacityValue + ')';

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('iaq_mon')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: this.props.width - 10 }}>
						<div className='noScrollBar' onScroll={this.handleOnScroll} style={{ height: this.props.height - 120, overflow: 'auto' }}>
							{/* <div> {JSON.stringify(this.props.param.iaq_monitoring_settings[this.props.param.room_name])} </div> */}

							<div style={{ width: '100%', display: 'inline-block', verticalAlign: 'top' }}>
								<div style={cell_style}>
									<div
										className="room_color"
										style={{
											display: 'block',
											margin: '10px 5px',
											padding: '10px',
											//border: '1px solid black',
											borderRadius: '10px',
											backgroundColor: roomRGBA,
											overflow: 'hidden',
											textOverflow: 'ellipsis'
										}}
									>
										<span style={{ marginLeft: '5px', fontSize: '110%', color: 'black', fontWeight: 'bold', opacity: '1.0', whiteSpace: 'nowrap' }}>  {room_name} </span>
									</div>

									{this.props.param.iaq_monitoring_settings[room_name].map((device, i) => {
										let deviceName = window.app.state.point_list[device.id].name;
										let unit = window.app.state.point_list[device.id].unit;

										if(isEmpty(unit)) {
											if(window.app.state.point_list[device.id].type == 'Ac') unit = 'DEG';
										}

										let typeTemp = this.props.receiver.getString(device.type);
										let avTemp = window.app.state.point_list[device.id].av;

										if(isEmpty(avTemp)) {
											if(window.app.state.point_list[device.id].type == 'Ac') {
												if(window.app.state.point_list[device.id].hasOwnProperty('temp')) {
													avTemp = window.app.state.point_list[device.id].temp;
												}
											}
										}

										let iaq_color = '#8BD5A7';
										//#cc3300, #ff9966, #ffcc00, #99cc33, #339900
										//red, 	   beige.	yellow,	 light green, green
										//#FF6D6A			#FDE26C				   #8BD5A7

										if (device.type == 'temp' || device.type == 'humi') {
											if (avTemp <= device.threshold_yellow || avTemp >= device.threshold_red) {
												iaq_color = '#FDE26C';
											}
										} else {
											if (avTemp >= device.threshold_red) {
												iaq_color = '#FF6D6A';
											} else {
												if (avTemp >= device.threshold_yellow) {
													iaq_color = '#FDE26C';
												}
											}
										}

										if(avTemp == null || avTemp == 'null') {
											avTemp = <span>&nbsp;</span>;
											iaq_color = '#8BD5A7';
										} else {
											avTemp = avTemp + this.props.receiver.getString(unit);
										}

										let iaqRGBA = 'rgba(' + rgbaCode[iaq_color].r + ', ' + rgbaCode[iaq_color].g + ', ' + rgbaCode[iaq_color].b + ', ' + opacityValue + ')';

										return (
											<div style={{ width: '45%', display: 'inline-block', marginLeft: '10px', marginBottom: '10px' }} onClick={() => this.selectedIAQValue(device)}>
												<div className="value" style={{ display: 'flex' }} ref={(divElement) => { this.divElement = divElement }}>
													<div style={{
														display: 'inline-block',
														width: this.state.height,
														height: this.state.height,
														//border: '1px solid black',
														borderRadius: '50%',
														backgroundColor: iaqRGBA
														//backgroundColor: iaq_color 
													}}>
														<img src={iconList[device.type]} style={{ width: this.state.height - 7, paddingTop: 3, paddingLeft: 3 }} />
													</div>
													<span style={{ display: 'inline-block', marginLeft: '5px' }}>
														<span style={{
															display: 'block',
															width: cell_width / 3,
															fontSize: '80%',
															color: '#707070',
															whiteSpace: 'nowrap',
															overflow: 'hidden',
															textOverflow: 'ellipsis'
														}}>
															{deviceName}
														</span>
														<span style={{
															display: 'block',
															width: cell_width / 3,
															fontSize: '80%',
															fontWeight: '500',
															whiteSpace: 'nowrap',
															overflow: 'hidden',
															textOverflow: 'ellipsis'
														}}>
															{avTemp}
															{/* {avTemp + this.props.receiver.getString(unit)} */}
															{/* { isEmpty(avTemp) ? <span> &nbsp; </span> : avTemp + this.props.receiver.getString(unit) } */}
														</span>
													</span>
												</div>
											</div>
										)
									})}

									{/* Charting element 'width: '100%', height: this.props.height-213' */}
									{/* this.state.selectedPoint && <div className="chart" style={{ width: '100%', height: this.props.height-213 }}>
										<div> ID: {this.state.selectedPoint.id} </div>
										<div> Type: {this.state.selectedPoint.type} </div>
										<div> Threshold yellow: {this.state.selectedPoint.threshold_yellow} </div>
										<div> Threshold red: {this.state.selectedPoint.threshold_red} </div>
									</div> */}
								</div>

								{this.state.selectedPoint && <Chart_Line
									style={{ paddingBottom: '60px' }}
									id={'IAQ_Mon_Details'}
									ref={this.chart}
									title={''}
									chart_width={chart_width}
									chart_height={chart_height}
									data={this.state.chartData}
									tick_values={this.state.tick_values}
									colors={this.state.colors}
									y_label={this.state.y_label}
									minValue={this.state.minValue}
									maxValue={this.state.maxValue}
									ygrids={[
										{ value: this.state.selectedPoint.threshold_yellow, class: this.state.yellowLabel },
										{ value: this.state.selectedPoint.threshold_red, class: this.state.redLabel }
									]}
									receiver={this.props.receiver}
								/>}

							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}